
class KienzleThumbStrip extends HTMLElement {
  #abortController;

  connectedCallback() {
    this.#abortController = new AbortController();

    const { signal } = this.#abortController;

    if (!this.scroller) return;

    this.prevButton?.addEventListener('click', () => this.#page(-1), { signal });
    this.nextButton?.addEventListener('click', () => this.#page(1), { signal });
    this.scroller.addEventListener('scroll', this.#updateButtons.bind(this), { signal, passive: true });
    window.addEventListener('resize', this.#updateButtons.bind(this), { signal });

    requestAnimationFrame(() => this.#updateButtons());
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  get scroller() {
    return this.querySelector('[data-thumb-scroller]');
  }

  get prevButton() {
    return this.querySelector('[data-prev]');
  }

  get nextButton() {
    return this.querySelector('[data-next]');
  }

  #page(direction) {
    this.scroller.scrollBy({
      left: this.scroller.clientWidth * direction,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  #updateButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scroller;

    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
    const fits = scrollWidth <= clientWidth + 1;

    this.classList.toggle('kienzle-thumbs--static', fits);

    if (this.prevButton) this.prevButton.disabled = atStart;
    if (this.nextButton) this.nextButton.disabled = atEnd;
  }
}

if (!window.customElements.get('kienzle-thumb-strip')) {
  window.customElements.define('kienzle-thumb-strip', KienzleThumbStrip);
}
